<!--
 * @Description: 
 * @Author: zhaoshuai
 * @Date: 2020-05-09 14:01:32
 * @LastEditTime: 2021-06-16 21:50:34
 * @LastEditors: dezhi
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
    let path = this.$route.path;
    history.replaceState(null, "", path);
    console.log(history);
  },
};
</script>
<style>
.pswp__caption__center {
  font-size: 28px !important;
}
@import "../public/response.css";
</style>
